import { ArrowLeft, Bell, Menu } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  showBack?: boolean;
  onBack?: () => void;
  showNotifications?: boolean;
  notificationCount?: number;
  onNotificationsClick?: () => void;
  showMenu?: boolean;
  onMenuClick?: () => void;
  rightAction?: React.ReactNode;
  className?: string;
  variant?: 'default' | 'primary' | 'gradient';
}

export function PageHeader({
  title,
  subtitle,
  showBack = false,
  onBack,
  showNotifications = false,
  notificationCount = 0,
  onNotificationsClick,
  showMenu = false,
  onMenuClick,
  rightAction,
  className = '',
  variant = 'default'
}: PageHeaderProps) {
  const getBackgroundClass = () => {
    switch (variant) {
      case 'primary':
        return 'bg-primary text-primary-foreground';
      case 'gradient':
        return 'bg-gradient-to-r from-primary to-[#14CAF4] text-white';
      default:
        return 'bg-card';
    }
  };

  return (
    <div className={`${getBackgroundClass()} p-6 ${variant === 'primary' || variant === 'gradient' ? 'rounded-b-3xl shadow-md' : ''} ${className}`}>
      <div className="flex items-center justify-between">
        {showBack && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onBack}
            className={variant === 'primary' || variant === 'gradient' ? 'text-white hover:bg-white/10' : ''}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
        )}
        
        <div className={`${showBack ? '' : 'flex-1'}`}>
          <h1 className={variant === 'primary' || variant === 'gradient' ? 'text-white' : ''}>{title}</h1>
          {subtitle && (
            <p className={`${variant === 'primary' || variant === 'gradient' ? 'text-white/80' : 'text-muted-foreground'} mt-1`}>
              {subtitle}
            </p>
          )}
        </div>

        <div className="flex items-center gap-2">
          {rightAction}
          
          {showNotifications && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onNotificationsClick}
              className={`relative ${variant === 'primary' || variant === 'gradient' ? 'text-white hover:bg-white/10' : ''}`}
            >
              <Bell className="h-5 w-5" />
              {notificationCount > 0 && (
                <Badge
                  variant="destructive"
                  className="absolute -top-1 -right-1 h-5 w-5 p-0 flex items-center justify-center"
                >
                  {notificationCount > 9 ? '9+' : notificationCount}
                </Badge>
              )}
            </Button>
          )}
          
          {showMenu && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onMenuClick}
              className={variant === 'primary' || variant === 'gradient' ? 'text-white hover:bg-white/10' : ''}
            >
              <Menu className="h-5 w-5" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
